
import { FormGroup } from "@angular/forms";
import { ILookUpType } from "../models/generic/lookup-type/lookup-type.model";
import { ISavedAddressDetailsModel } from "../models/saved-address/saved-address-details.model";
import { ISavedContactDtoModel } from "../models/saved-contact/dto/saved-contact-dto.model";
import { ISavedContactPostDtoModel } from "../models/saved-contact/dto/saved-contact-post-dto.model";
import { ISavedContactPutDtoModel } from "../models/saved-contact/dto/saved-contact-put-dto.model";
import { ISavedContactModel } from "../models/saved-contact/saved-contact.model";
import { IModelMapping } from "./generic/model.mapping";
import { SavedAddressMapping } from "./saved-address.mapping";

export class SavedContactMapping implements IModelMapping<ISavedContactDtoModel, ISavedContactModel>  {
    toPutModel(model: ISavedContactModel, customerId: string): ISavedContactPutDtoModel {
        return {
            ...model,
            customerId: customerId,
            addressId: model.address.id,
            languageCode: model.language?.code,
        } as ISavedContactPutDtoModel;
    }
    toPostModel(model: ISavedContactModel, customerId: string): ISavedContactPostDtoModel {
        return {
            ...model,
            customerId: customerId,
            addressId: model.address.id,
            languageCode: model.language?.code
        } as ISavedContactPostDtoModel;
    }
    constructor() {}
    toApplicationModel(model: ISavedContactDtoModel): ISavedContactModel {

        /*model = {
            id: '1234',
            firstName: 'Mathew',
            lastName: "Woodhall",
            isDefault: false,
            emailAddress: 'mathew.woodhall@gmail.com',
            address: {
                "id": "2d38e44c-ea66-455d-bef5-80acfc1d3e2b",
                "details": {
                    "name": "!!!!TEST TEST TEST!!!!!",
                    "addressLine1": "PTDA TRENCAES SN",
                    "addressLine2": '',
                    "townCity": "Onda",
                    "countyState": "Castellón",
                    "postalCode": "12200",
                    "countryName": "France",
                    "countryCode": "FR",
                    "country": {
                        name: "United Kingdom",
                        code: "GB",
                    } as ILookUpType,
                    "isBillTo": true,
                    "isBillToDefault": true,
                    "isDefault": true,
                    "isResidentialAddress": true,
                    "isShipTo": false,
                    "isShipToDefault": false,
                    "isVerified": true
                } as ISavedAddressDetailsModel
            },
            language: {
                code: 'EN',
                name: 'English'
            } as ILookUpType,
            title: 'Mr',
            telephoneNumber: '01215001503',
            isCreditNoteRecipient: false,
            isEmailAddressVerified: false,
            isInvoiceRecipient: false,
            isMarketingRecipient: false,
            isOrderProgressRecipient: false,
            isRemarketTheBasketRecipient: false,
            isShippingNotificationRecipient: false,
            jobTitle: 'Test',
            mobileNumber: '07799836927'
        }*/

        return { 
            ...model,
            fullName: `${model.title ? model.title + ' ' : ''}${model.firstName ? model.firstName + ' ' : ''}${model.lastName}`,
            concatenatedContact: `${model.title ? model.title + ' ' : ''}${model.firstName ? model.firstName + ' ' : ''}${model.lastName}, ${model.telephoneNumber ? model.telephoneNumber : (model.mobileNumber ? model.mobileNumber : 'No phone number')}, ${model.emailAddress ? model.emailAddress : 'No email address'}`,
        } as ISavedContactModel;
    }
    toDtoModel(model: ISavedContactModel): ISavedContactDtoModel {
        return { ...model } as ISavedContactDtoModel;
    }
    toDtoModels(models: ISavedContactModel[]): ISavedContactDtoModel[] {
        return { ...models } as ISavedContactDtoModel[];
    }
    toApplicationModels(models: ISavedContactDtoModel[]): ISavedContactModel[] {
        return { ...models } as ISavedContactModel[];
    }

    toApplicationDetailModel(resultDto: ISavedContactDtoModel): ISavedContactModel {
        let addressMapping = new SavedAddressMapping()
        return {
            ...resultDto,
            address: addressMapping.toApplicationModel(resultDto.address),
        } as ISavedContactModel;
    }

    toModelFromForm(group: FormGroup, ): ISavedContactModel {
        return {
            id: group?.controls?.id?.value ?  group.controls.id.value : undefined,
            title: group?.controls?.title.value ?  group.controls.title.value.name : '',
            firstName: group?.controls?.firstName?.value ?  group.controls.firstName.value : '',
            lastName: group?.controls?.lastName?.value ?  group.controls.lastName.value : '',
            jobTitle: group?.controls?.jobTitle?.value ?  group.controls.jobTitle.value : '',
            emailAddress:  group?.controls?.emailAddress?.value ?  group.controls.emailAddress.value : '',
            telephoneNumber: group?.controls?.telephoneNumber?.value ?  group.controls.telephoneNumber.value : null,
            mobileNumber:  group?.controls?.mobileNumber.value ?  group.controls.mobileNumber.value : null,
            address:  group?.controls?.address?.value ?  group.controls.address.value : '',
            language: group?.controls?.language?.value ?  group.controls.language.value.code : '',
            isDefault: group?.controls?.isDefault?.value ?  group.controls.isDefault.value : false,
            isMarketingRecipient:  group?.controls?.isMarketingRecipient?.value ?  group.controls.isMarketingRecipient.value : false,
            isOrderProgressRecipient: group?.controls?.isOrderProgressRecipient?.value ?  group.controls.isOrderProgressRecipient.value : false,
            isShippingNotificationRecipient:  group?.controls?.isShippingNotificationRecipient.value ?  group.controls.isShippingNotificationRecipient.value : false,
            isInvoiceRecipient:  group?.controls?.isInvoiceRecipient?.value ?  group.controls.isInvoiceRecipient.value : false,
            isCreditNoteRecipient:  group?.controls?.isCreditNoteRecipient?.value ?  group.controls.isCreditNoteRecipient.value : false,
        } as ISavedContactModel;
    }

    toModelFromDefaultContact(group: FormGroup): ISavedContactModel {

        return group.controls.defaultContact.value as ISavedContactModel;
       
    }

}
